<div
  class="container-fluid payment-container d-flex flex-column justify-content-center align-items-center"
  [dir]="dir"
>
  @if (pSummary) {
    <div class="row w-100">
      <!-- Payment Summary Section -->
      <div class="col-md-6 offset-md-1 payment-summary-section mt-5">
        <div class="card p-4 shadow payment-summary">
          <div class="mb-4 d-none d-sm-block">
            <img
              [src]="'assets/flyplus/app-logo.svg' | assets"
              alt="App Logo"
              class="mb-3 app-logo"
            />
          </div>
          <div class="payment-summary-details ahoy-secondary-card mb-4">
            <h3 class="" translate>Payment Summary</h3>
            <div class="row">
              <div class="col-sm-6">
                <div class="d-flex justify-content-between flex-column mt-3">
                  <span class="text-muted" translate>Total Amount</span>
                  <span class="font-weight-bold amout">
                    <currency-symbol
                      [type]="pSummary.currency"
                    ></currency-symbol>
                    <span>{{
                      pSummary.amount.toFixed(2) | numberTranslate
                    }}</span></span
                  >
                </div>
                <div class="d-flex justify-content-between flex-column mt-3">
                  <span class="text-muted" translate>Date</span>
                  <span>{{
                    pSummary.paymentDate
                      | date: 'dd/MM/yyyy | h:mm a'
                      | numberTranslate
                  }}</span>
                </div>
                <div class="d-flex justify-content-between flex-column mt-3">
                  <span class="text-muted" translate>Transaction ID</span>
                  <span>{{ pSummary.referenceKey }}</span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="d-flex justify-content-between flex-column mt-3">
                  <span class="text-muted" translate
                    >Booking/Left Behind ID</span
                  >
                  <span>{{
                    pSummary.bookingId || pSummary.lblId | numberTranslate
                  }}</span>
                </div>
                <div class="d-flex justify-content-between flex-column mt-3">
                  <span class="text-muted" translate>Payment Status</span>
                  <div>
                    <span
                      class="badge"
                      [ngClass]="{
                        'bg-success': isSuccess,
                        'bg-danger': !isSuccess,
                      }"
                      >{{ pSummary.status }}</span
                    >
                  </div>
                </div>
                @if (pSummary.data?.invoicePdfLink) {
                  <div class="d-flex justify-content-between flex-column mt-3">
                    <span class="text-muted" translate>Invoice</span>
                    <a [href]="pSummary.data.invoicePdfLink" target="_blank">
                      <span class="badge bg-primary">
                        <div class="d-flex align-items-center">
                          <mat-icon>cloud_download</mat-icon>
                          &nbsp;
                          <span translate>View/Download</span>
                        </div>
                      </span>
                    </a>
                  </div>
                }
                @if (pSummary.data?.cardHolderNmae) {
                  <div class="d-flex justify-content-between flex-column mt-3">
                    <span class="text-muted" translate>Card Holder Name</span>
                    <span>{{ pSummary.data.cardHolderNmae }}</span>
                  </div>
                }
                @if (pSummary.data?.cardNumber) {
                  <div class="d-flex justify-content-between flex-column mt-3">
                    <span class="text-muted" translate>Card Number</span>
                    <span>{{ pSummary.data.cardNumber }}</span>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- success Illustration Section -->
      @if (isSuccess) {
        <div class="col-md-5 Illustration-section text-center">
          <img
            [src]="'assets/flyplus/payment-success.svg' | assets"
            alt="Success"
            class="Illustration-image"
          />
          <h4 class="mt-3" translate>Thank you for your payment</h4>
          <div class="text-center mt-2">
            <button mat-button class="btn btn-primary" (click)="redirectTo()">
              <span translate>View Booking Details</span>
            </button>
          </div>
          <br />
        </div>
      }
      <!-- failed Illustration Section -->
      @if (!isSuccess) {
        <div class="col-md-5 Illustration-section text-center">
          <img
            [src]="'assets/flyplus/payment-fail.svg' | assets"
            alt="Failed"
            class="Illustration-image"
          />
          <h4 class="mt-3" translate>Payment failed, please try again</h4>
          <div class="text-center mt-2">
            <a [href]="pSummary.paymentLink" mat-button class="btn btn-primary"
              ><span translate>Try Again</span></a
            >
          </div>
          <br />
        </div>
      }
    </div>
  }
  @if (!pSummary && isLoading) {
    <div class="w-100 text-center">
      <app-loader [isLoading]="isLoading"></app-loader>
    </div>
  }
  <div class="my-5">
    <img [src]="'assets/flyplus/powered-by.png' | assets" width="130" />
  </div>
</div>
